export type AddProductWithComboOptions = {
	onFastAdd: (product: any) => void;
	onOpenCard?: (productId: string) => void | Promise<void>;
};

export async function addProductWithCombo(product: any, options: AddProductWithComboOptions): Promise<void> {
	if (!product?.id) {
		options.onFastAdd(product);
		return;
	}

	const productId = String(product.id);

	const needsCard = !!(product.modifiers?.length || product.group_modifiers?.length || product.sizes?.length || product.has_combo === true);

	if (needsCard && options.onOpenCard) {
		await Promise.resolve(options.onOpenCard(productId));
		return;
	}

	options.onFastAdd(product);
}
